/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icons/arrow-left-transparent': {
    width: 16,
    height: 12,
    viewBox: '0 0 16 12',
    data: '<path pid="0" d="M6.13 12l1.048-1L2.84 6.714H16V5.286H2.841L7.178 1 6.13 0 0 6l6.13 6z" />'
  }
})